import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuex from "./store/index";
import installElementPlus from "./plugins/element";
import installGlobalComp from "./api/globalComponents.js";
import "./utils/dayjs.js";
import "./style/init.css";

// 1. 引入图标
import { ArrowRight } from '@element-plus/icons-vue';

const app = createApp(App);

installElementPlus(app);
installGlobalComp(app);

// 2. 注册为全局组件
app.component('ArrowRight', ArrowRight);

app.use(router);
app.use(vuex);
app.mount("#app");
